export const removeAuthToken = () => {
  return localStorage.removeItem("auth_token");
};

export const setAuthToken = (token) => {
  return localStorage.setItem("auth_token", token);
};

export const getAuthToken = () => {
  return localStorage.getItem("auth_token");
};

export const setToken = (token) => {
  return sessionStorage.setItem("token", token);
};
export const setaccessToken = (token) => {
  return sessionStorage.setItem("accessToken", token);
};

export const getToken = () => {
  return sessionStorage.getItem("token");
};

export const removeToken = () => {
  return sessionStorage.removeItem("token");
};

export const setPath = (path) => {
  return sessionStorage.setItem("path", path);
};

export const getPath = () => {
  return sessionStorage.getItem("path");
};

export const setCountry = (value) => {
  let country = value;
  return sessionStorage.setItem("country", JSON.stringify(country));
};

export const getCountrydata = () => {
  return sessionStorage.getItem("country");
};

export const setState = (value) => {
  let state = value;
  return sessionStorage.setItem("state", JSON.stringify(state));
};

// Retrieve state from session storage
export const getStatedata = () => {
  return sessionStorage.getItem("state");
};

export const getClgToken = () =>{
  return sessionStorage.getItem("clg_token");
}

export const setClgToken = (token) =>{
  return sessionStorage.setItem("clg_token", token);
}
